exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CheckboxGroup-06c20dca{margin:0 0 20px 0}\n", ""]);

// Exports
exports.locals = {
	"CheckboxGroup": "CheckboxGroup-06c20dca"
};